import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ClipboardList, FileText, PenLine, Trash2, Loader2 } from "lucide-react";
import { API, authHeaders } from "./shared";

export default function OrdersTable({ items, onEdit, onRefresh }) {
  const [deletingId, setDeletingId] = useState(null);

  const remove = async (o) => {
    const ok = window.confirm(
      `Eliminare l'ordine ${o.order_number}?\n\n` +
      `Verranno ripristinati gli articoli nell'inventario e cancellato il movimento di uscita collegato. ` +
      `Se l'ordine proviene da una richiesta, questa tornerà "in attesa".`
    );
    if (!ok) return;
    setDeletingId(o.id);
    try {
      await axios.delete(`${API}/admin/warehouse/orders/${o.id}`, authHeaders());
      toast.success("Ordine eliminato");
      onRefresh?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore nell'eliminazione");
    } finally {
      setDeletingId(null);
    }
  };

  if (!items.length) return <div className="bg-white border border-zinc-200 rounded-sm p-8 text-center text-zinc-400">Nessun ordine preparato</div>;

  return (
    <div className="space-y-2">
      {items.map((o, i) => (
        <div key={o.id || i} className="bg-white border border-zinc-200 rounded-sm px-4 py-3" data-testid={`order-row-${i}`}>
          <div className="flex items-center gap-3">
            <div className="bg-blue-100 text-blue-600 w-8 h-8 rounded-sm flex items-center justify-center"><ClipboardList size={16} /></div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-sm">{o.order_number} — {o.company || o.client_name}</p>
              <div className="flex items-center gap-2 mt-0.5">
                {o.ddt_number && <span className="px-1.5 py-0.5 bg-zinc-100 text-zinc-600 text-[10px] font-bold font-mono rounded">{o.ddt_number}</span>}
                <span className="text-xs text-zinc-400">{o.destination?.city || ""} | {o.created_at?.slice(0,10)} | {o.items?.length || 0} art.</span>
              </div>
            </div>
            {o.cost > 0 && <span className="text-sm font-bold text-[#FF5200]">{o.cost.toFixed(2)} EUR</span>}
            <button onClick={() => onEdit(o)} data-testid={`order-edit-${i}`}
              className="flex items-center gap-1 px-3 py-1.5 border border-zinc-200 text-xs font-bold uppercase rounded-sm hover:bg-zinc-50 text-zinc-600">
              <PenLine size={14} /> Modifica
            </button>
            <a href={`${API}/admin/warehouse/orders/${o.id}/ddt?token=${localStorage.getItem("mv_admin_token")}`} target="_blank" rel="noreferrer"
              className="flex items-center gap-1 px-3 py-1.5 bg-[#09090B] text-white text-xs font-bold uppercase rounded-sm hover:bg-zinc-700" data-testid={`order-ddt-${i}`}>
              <FileText size={14} /> DDT
            </a>
            <button
              onClick={() => remove(o)}
              disabled={deletingId === o.id}
              title="Elimina ordine (ripristina inventario)"
              className="flex items-center gap-1 px-3 py-1.5 border border-red-200 text-red-700 bg-white text-xs font-bold uppercase rounded-sm hover:bg-red-50 disabled:opacity-50"
              data-testid={`order-delete-${i}`}
            >
              {deletingId === o.id ? <Loader2 size={14} className="animate-spin" /> : <Trash2 size={14} />}
              Elimina
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
